import { useEffect, useRef } from "react";

/**
 * A hook that scrolls a container to the top when a dependency changes.
 *
 * @param selectedIndex - The selected index to watch for changes.
 * @returns A ref that should be attached to `<SheetContent>`.
 */
export const useScrollToSheetTopOnSelectedIndexChange = (
  selectedIndex: number | null,
) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      // Temporarily prevent scrolling to prevent layout shifts.
      containerRef.current.style.overflow = "hidden";
      containerRef.current.scrollTop = 0;

      // Restore scrolling after a short delay.
      const timer = setTimeout(() => {
        if (containerRef.current) {
          containerRef.current.style.overflow = "";
        }
      }, 100);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [selectedIndex]);

  return containerRef;
};
